<!--
  This dialog will be used to fill the client's response for grocery popup.
-->
<template>
  <dialog-form
    class="grocery-popup-dialog"
    :show-dialog="isShowDialog"
    :is-required="true"
    @open="dialogOpen"
    @cancel="hideDialog"
    @submit="submitForm"
  >
    <template #title>
      Tell the User about GoGo's Grocery Service!
    </template>

    <div class="row align-items-center">
      <div class="col-sm-12">
        It looks like this client is going to or coming from a grocery store, please ask them if they'd be interested in more information
        about GoGo's delivery service which would help them save up to 50% of their grocery fees. We can follow up with an email or phone
        call with more information.
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <label class="control-label"> Client's Response* </label>
        <dropdown-list
          v-model="groceryPopupResponse.clientResponse"
          placeholder="Please choose client's response"
          required
          :options="clientResponseList"
        />
      </div>
    </div>

    <template v-if="isNotInterested">
      <div class="row">
        <div class="col-12">
          <label class="control-label"> Reason* </label>
          <dropdown-list
            v-model="groceryPopupResponse.notInterestedReason"
            required
            :options="notInterestedReasonList"
          />
        </div>
      </div>

      <div
        v-if="isNotInterestedOtherReason"
        class="row"
      >
        <div class="col-12">
          <label class="control-label"> Other Reason* </label>
          <sanitized-textarea
            v-model="groceryPopupResponse.otherReason"
            required
          />
        </div>
      </div>
    </template>
  </dialog-form>
</template>

<script lang="ts">
import { ref, Ref, computed } from 'vue';

import util from '@/Utils/util';

const dialogId = 'grocery-popup-dialog';

const clientResponseList = [
  { id: 1, key: 'Interested to learn more', label: 'Interested to learn more' },
  { id: 2, key: 'Not interested', label: 'Not interested' },
];
const notInterestedReasonList = [
  { id: 1, key: 'No Reason', label: 'No Reason' },
  { id: 2, key: 'Already know about it', label: 'Already know about it' },
  { id: 3, key: 'Prefers going to grocery store on their own', label: 'Prefers going to grocery store on their own' },
  { id: 4, key: 'Prefers ordering groceries themselves', label: 'Prefers ordering groceries themselves' },
  { id: 5, key: "Thinks it's too expensive", label: "Thinks it's too expensive" },
  { id: 6, key: 'Other Reason', label: 'Other Reason' },
];

export default {
  name: 'GroceryPopupDialog',

  props: {
    isShowDialog: {
      type: Boolean,
      default: false,
    },
  },

  emits: ['submit', 'cancel'],

  setup: (props: any, context: any) => {
    const { emit } = context;

    const groceryPopupResponse: Ref<any> = ref({
      clientResponse: 'Interested to learn more',
      notInterestedReason: '',
      otherReason: '',
    });

    const isNotInterested = computed(() => {
      return groceryPopupResponse.value.clientResponse === clientResponseList[1].key;
    });

    const isNotInterestedOtherReason = computed(() => {
      return groceryPopupResponse.value.notInterestedReason === notInterestedReasonList[5].key;
    });

    const dialogOpen = () => {
      groceryPopupResponse.value.clientResponse = 'Interested to learn more';
      groceryPopupResponse.value.notInterestedReason = '';
      groceryPopupResponse.value.otherReason = '';
    };

    const submitForm = () => {
      let notInterestedReason;
      if (isNotInterested.value && isNotInterestedOtherReason.value) {
        notInterestedReason = groceryPopupResponse.value.otherReason;
      } else if (isNotInterested.value) {
        notInterestedReason = groceryPopupResponse.value.notInterestedReason;
      }

      const postData: any = {
        clientResponse: groceryPopupResponse.value.clientResponse,
        notInterestedReason,
      };

      emit('submit', postData);
    };

    const hideDialog = () => {
      emit('cancel');
    };

    return {
      dialogId,
      clientResponseList,
      notInterestedReasonList,
      isNotInterested,
      isNotInterestedOtherReason,
      groceryPopupResponse,

      util,

      dialogOpen,
      submitForm,
      hideDialog,
    };
  },
};
</script>

<style lang="scss">
.grocery-popup-dialog {
  &.el-dialog {
    min-width: 700px !important;
  }
  .control-label {
    color: #252422 !important;
    font-weight: 500 !important;
  }
}
</style>
